import AppPage from './AppPage.vue'

export default AppPage
